import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import { arrayOf, bool, func, object, string } from 'prop-types';
import { get } from 'lodash';
import { CAMPAIGN_SEARCH_INSTRUCTIONS_TYPES, ORG_SETTING_CONNECTION_CUSTOM_LABEL } from '../../helpers/constant';

import styles from './styles.scss';
import classNames from 'classnames';

export const CAMPAIGN_SEARCH_INSTRUCTIONS = 'campaign_search_instruction';
export const MAXIMUM_TEXT_LIMIT = 600;

export class CampaignSearchInstructions extends Component {
  static propTypes = {
    className: string,
    saveBtnLabel: string,
    updateAppSettingSaga: func,
    appSetting: arrayOf(object),
    getAppSettingSaga: func,
    campaignSearchInstructionTitle: string,
    campaignSearchInstructionDescription: string,
    isEnabledPixelConnectionType: bool,
    maximumTextLimitHelper: string,
  };

  static defaultProps = {
    campaignSearchInstructionTitle: 'Campaign Search Instructions',
    campaignSearchInstructionDescription:
      `Add optional text in addition to Attribute's standard search instructions, such as organizational-specific examples or workflow elements, to assist your users with successful search inputs.`,
      maximumTextLimitHelper: 'Maximum character limit is 600 (excluding spaces). Please reduce text to save.',
  };


  handleChangeInstructionText = key => e => { 
    const { onChange, data } = this.props;

    const newData = {
      ...data,
      [key]: {
        value: e.target.value,
        search_instruction_name: key
      }
    };

    onChange &&
    onChange({
      setting_name: CAMPAIGN_SEARCH_INSTRUCTIONS,
      setting_value: newData
    });

  };

  drawCampaignSearchInstruction = () => {
    const { data, maximumTextLimitHelper } = this.props;

    return (
      <ul className={styles.connectionTypesContainer}>
        {CAMPAIGN_SEARCH_INSTRUCTIONS_TYPES.map(option => {
          const { name, subtitle, key, additionText, descriptiveText } = option || {};
          const value = get(data, `${key}.value`, '');
          const formatValue = String(value).split(" ").join("");
          const isMaximumTextLimit = formatValue.length > MAXIMUM_TEXT_LIMIT;

          return (
              <div className={styles.searchInstructionsItem}>
                <span className={styles.searchInstructionsLabel}>{name}</span>
                <span className={styles.searchInstructionsSubtitle}>{subtitle}</span>
                <span className={styles.searchInstructionsAdditionText}>{additionText}</span>
                <TextField
                  variant="outlined"
                  multiline
                  maxRows={3} 
                  className={styles.connectionTypeInput}
                  helperText={isMaximumTextLimit && maximumTextLimitHelper}
                  error={isMaximumTextLimit}
                  inputProps={{
                    style: {
                      minHeight: '36px',
                      height: '60px',
                      fontSize: '11px',
                      width: '800px',
                      overflow: 'auto'
                    }
                  }}
                  value={value}
                  onChange={this.handleChangeInstructionText(key)}
                  placeholder={descriptiveText}
                />
              </div>
          );
        })}
      </ul>
    );
  };

  render() {
    const {
      className: customClassName,
      campaignSearchInstructionTitle,
      campaignSearchInstructionDescription,
    } = this.props;

    return (
      <div
        className={classNames(customClassName, styles.advertiserConfigWrapper)}
      >
        <div className={styles.settingItem}>
          <h2 className={styles.title}>{campaignSearchInstructionTitle}</h2>
          <p className={styles.description}>
            {campaignSearchInstructionDescription}
          </p>
          {this.drawCampaignSearchInstruction()}
        </div>
      </div>
    );
  }
}

export default CampaignSearchInstructions;

